<template>
    <div class="head" :style="{'height': s === 'BS' ? '190px': '165px', 'paddingTop': s === 'BS' ? '25px': ''}">
        <nav-bar nav-bar-type="transparent"  navBarTitle="完善企业资料"></nav-bar>
        <img src="@/assets/img/poster-img/head-left-icon.png" alt="">
        <div style="position: relative">
            <div @click="popupHandle" class="title"><span class="ellipsis title-text">{{companyInfo.companyName}}</span><span class="iconfont title-modify">&#xe617;</span></div>
            <div class="title-box">
                <!-- <i class="iconfont head-icon">&#xe69e;</i> -->
                <!-- <div class="sub-title sub-title-left">我们承诺无授权不对外公开</div> -->
                <div class="sub-title sub-title-right">资料完善度 <span>{{companyInfo.materialCompleteRate}}%</span></div>
            </div>
        </div>
        <van-popup v-model="isShowCompany" round position="bottom" :style="{ height: '70%' }" :closeable="true" :afe-area-inset-bottom="true">
            <span class="iconfont popup-icon">&#xe694;</span>
            <h3 class="company-title">{{companyInfo.companyName}}</h3>
            <div class="company-text">企业名称已锁定，如需要更换企业请联系客服</div>
            <button class="company-btn" @click="contactHandle">联系客服</button>
            <a id="telphone" :href="'tel:'+mobile" style="display:none">{{ mobile }}</a>
        </van-popup>
    </div>
</template>
<script>
import { expertTelephone } from "@/api/api_home.js"
export default {
    props:{
        companyInfo:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data(){
        return {
            isShowCompany:false,
            mobile:'',
            s: localStorage.getItem('s')
        }
    },
    methods:{
        async call() {
                let comment = document.getElementById('telphone');
				if (document.all) {
					comment.click();
				} else if (document.createEvent) {
					let ev = document.createEvent('MouseEvents');
					ev.initEvent('click', false, true);
					comment.dispatchEvent(ev);
				}
			},
		// 获取客服电话
    async contactHandle(){
            let params={
                consultType:1
            }
        await expertTelephone(params).then(res=>{
                if(res.ok===true){
                    this.mobile=res.data.expertMobile
                    // 客服电话埋点
                    // eslint-disable-next-line
                    sensors.track('customerServicePhoneClick', {
                        customer_service_phone: this.mobile
                    });
                }
            })
            this.call()
        },
        popupHandle(){
            this.isShowCompany=true
        }

    }
}
</script>
<style lang="less" scoped>
.head{
    background-color: @blue;
    position: relative;
    height:132px;
    /deep/ .van-icon-cross::before{
        position: fixed;
        right: 15px;
    }
    img{
        position: absolute;
        bottom: 0px;
        width:100%;
        height:150px;
        right: 0;
    }
    .title-box{
        display: flex;
        align-items: center;
    }
    .title{
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:20px;
        position: absolute;
        top:66px;
        left: 16px;
        display: flex;
        align-items: center;
        .title-text{
            display: inline-block;
            max-width: 260px;
            margin-right: 5px;
        }
        .title-modify{
            font-size: 16px;
        }
    }
    .head-icon{
        font-size: 14px;
        color: #AFD1FF;
        position: absolute;
        left: 16px;
        top:106px;
    }
    .sub-title{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(175,209,255,1);
        line-height:12px;
        position: absolute;
        top:108px;
    }
    .sub-title-left{
        left: 35px;
    }
    .sub-title-right{
        left: 18px;
        span{
            color:rgba(255,255,255,1);
        }
    }
    .popup-icon{
    font-size: 60px;
    color: #cccccc;
    display: flex;
    justify-content: center;
    margin: 95px auto 20px;
}
.company-title{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:24px;
margin-top:25px;
text-align: center;
padding: 0 20px;
}
.company-text{
    font-size:12px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(51,51,51,1);
line-height:12px;
text-align: center;
margin-top:123px;
}
.company-btn{
    width:315px;
height:44px;
background:rgba(57,141,255,1);
box-shadow:0px 5px 10px 0px rgba(57,141,255,0.3);
border-radius:22px;
font-size:16px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:44px;
border: 0;
outline: none;
margin:20px auto 0;
text-align: center;
display: block;
}
}
</style>
